import { Box, Tab, Tabs } from '@mui/material';
import { PropsWithChildren, useState } from 'react';
import { ObjectDataViewer } from './ObjectDataViewer';
import { ObjectDataViewerSkeleton } from './skeletons/ObjectDataViewerSkeleton';

type TabPanelProps = PropsWithChildren<{ isHidden: boolean }>;

const TabPanel = ({ children, isHidden }: TabPanelProps) => {
  return (
    <Box role="tabpanel" hidden={isHidden}>
      {children}
    </Box>
  );
};

type Props = {
  valueTitle: string;
  metadataTitle: string;
  value: object | null;
  metadata: object | null;
  loading: boolean;
  enableClipboard?: boolean;
};

export const ResourceSummaryTabs = ({ value, metadata, valueTitle, metadataTitle, loading, enableClipboard }: Props) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  if (loading) {
    return <ObjectDataViewerSkeleton />;
  }
  if (value === null && metadata === null) {
    return null;
  }
  if (metadata === null) {
    return <ObjectDataViewer loading={loading} value={value} enableClipboard={enableClipboard} />;
  }
  if (value === null) {
    return <ObjectDataViewer loading={loading} value={metadata} enableClipboard={enableClipboard} />;
  }

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={currentTabIndex} onChange={(_, value: number) => setCurrentTabIndex(value)} variant="fullWidth">
          <Tab sx={{ fontSize: '0.75rem' }} label={valueTitle} />
          <Tab sx={{ fontSize: '0.75rem' }} label={metadataTitle} />
        </Tabs>
      </Box>
      <TabPanel isHidden={currentTabIndex !== 0}>
        <ObjectDataViewer loading={loading} value={value} enableClipboard={enableClipboard} />
      </TabPanel>
      <TabPanel isHidden={currentTabIndex !== 1}>
        <ObjectDataViewer loading={loading} value={metadata} enableClipboard={enableClipboard} />
      </TabPanel>
    </Box>
  );
};
